import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

export default () => Handlebars.compile(`{{! NOTE(jeresig): Display case is not usable with a screen reader.
    Disable the link for now until we're able to sort it out. }}
<a class="display-case-cover" href="javascript:void(0)" tabIndex="-1">
{{! Make badge overlays in the display-case cover for informative tooltips }}
<div class="achievement-badge compact badge-overlay"></div>
<div class="achievement-badge compact badge-overlay"></div>
<div class="achievement-badge compact badge-overlay"></div>
<div class="achievement-badge compact badge-overlay"></div>
<div class="achievement-badge compact badge-overlay"></div>
<span class="sr-only">${t`Edit badge display case.`}</span>
</a>
<div class="main-case fancy-scrollbar"></div>
<div class="badge-picker fancy-scrollbar"></div>
`) as any;
